export default {
  getCurrentModel (state: any) {
    return state.currentModel;
  },
  getFakerList (state: any) {
    return state.fakerList;
  }
};
